<template>
  <BaseDialog
    v-model="visible"
    :hasBodyMargin="false"
    :appendToBody="true"
    size="lg"
    @close="$emit('close')"
  >
    <ReferenceForm 
      :reference="reference"
      @cancel="visible = false"
      @save="onReferenceCreated"
    />
  </BaseDialog>
</template>
<script>
import ReferenceForm from "@/modules/projects/components/ReferenceForm.vue";

export default {
  components: {
    ReferenceForm,
  },
  props: {
    reference: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    onReferenceCreated(reference) {
      this.$emit('save', reference);
      this.visible = false
    }
  }
}
</script>
